import { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const API_BASE_URL = process.env.REACT_APP_API_URL || '';

const useRegisterForm = () => {
  const [usuario, setUsuario] = useState({
    nombre: '',
    correo: '',
    contrasena: '',
    rol: 'Estudiante',
    facultad: ''
  });

  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const navigate = useNavigate();

  const handleChange = (e) => {
    setUsuario({ ...usuario, [e.target.name]: e.target.value });
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  // (opcional) incluir token si existe, sin romper el flujo actual
  const getAuthConfig = () => {
    const token = localStorage.getItem('token');
    return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
  };

  // 🔹 LÓGICA CENTRAL DE REGISTRO (reutilizable por el form y por el masivo)
  const submitOne = async (u) => {
    // Usa el mismo endpoint que ya tenías en handleSubmit
    return axios.post(`${API_BASE_URL}/api/usuarios`, u, getAuthConfig());
  };

  // 🔹 Envío del formulario 1 a 1 (igual que antes, pero reutilizando submitOne)
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccessMessage('');
    try {
      await submitOne(usuario);
      setSuccessMessage('Se ha registrado correctamente');
      setTimeout(() => {
        navigate('/');
      }, 3000);
    } catch (error) {
      console.error('Error al registrar usuario:', error);
      if (error.response?.data?.mensaje) {
        setError(error.response.data.mensaje);
      } else if (error.request) {
        setError('No se pudo conectar con el servidor. Por favor, intenta de nuevo más tarde.');
      } else {
        setError('Error al registrar usuario. Por favor, intenta de nuevo.');
      }
    }
  };

  // 🔹 Registrar UNO de forma programática (sin form)
  const registerOne = async (u) => {
    try {
      await submitOne(u);
      return { ok: true };
    } catch (err) {
      return { ok: false, error: err?.response?.data?.mensaje || err.message || 'Error desconocido' };
    }
  };

  // 🔹 Registrar MUCHOS (p. ej., filas leídas desde Excel)
  //    rows = [{nombre, correo, contrasena, rol, facultad}, ...]
  const registerMany = async (rows = []) => {
    const report = { inserted: 0, errors: [] };
    for (let i = 0; i < rows.length; i++) {
      const r = rows[i];
      const res = await registerOne(r);
      if (res.ok) report.inserted++;
      else report.errors.push({ row: i + 2, message: res.error }); // +2 por encabezado y base 1
    }
    return report;
  };

  return {
    usuario,
    showPassword,
    error,
    successMessage,
    handleChange,
    togglePasswordVisibility,
    handleSubmit,
    // 👇 nuevos helpers para el botón de carga masiva
    registerOne,
    registerMany,
  };
};

export default useRegisterForm;
